import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { EventEmitter } from '@ciceksepeti/cs-event-emitter';
import Events from '@constants/events';
var RouteEvents = function () {
    var pathname = useLocation().pathname;
    useEffect(function () {
        var eventEmitter = new EventEmitter();
        eventEmitter.dispatch(Events.PATHNAME_CHANGE, { pathname: pathname });
    }, [pathname]);
    return null;
};
export default RouteEvents;
